/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  Strucutre:
          url     => router path
          name    => name to display in sidebar
          slug    => router path name
          icon    => Feather Icon component/icon name
          tag     => text to display on badge
          tagColor  => class to apply on badge element
          i18n    => Internationalization
          submenu   => submenu of current item (current item will become dropdown )
                NOTE: Submenu don't have any icon(you can add icon if u want to display)
          isDisabled  => disable sidebar item/group
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
export default [
  {
    url: null,
    name: "Mi Perfil",
    slug: "Mi Perfil",
    icon: "UserIcon",
    i18n: "Mi Perfil",
    submenu: [
      {
        url: '/idiomas/datos_user',
        name: "AlumnosCe",
        slug: "AlumnosCe",
        i18n: "Perfil",
      },
     ]
  },
  {
    url: null,
    name: "Servicios escolares",
    slug: "alumnos",
    icon: "CheckSquareIcon",
    i18n: "Servicios escolares",
    submenu: [
      {
        url: '/alumnos/calendarioescolar',
        name: "Calendario Escolar",
        slug: "calendarioEscolar",
        i18n: "Calendario Escolar",
      },
      {
        url: '/idiomas/inf_alumnos',
        name: "Alumnos",
        slug: "alumnos",
        i18n: "Alumnos",
      }
    ]
  },

  {
    url: null,
    name: "Grupos",
    slug: "Grupos",
    icon: "UsersIcon",
    i18n: "Grupos",
    submenu: [
      {
        url: '/idiomas/grupos',
        name: "Grupos",
        slug: "grupos",
        i18n: "Grupos",
      }
      
      // {
      //   url: '/directores/competencias',
      //   name: "Materias por Competencias",
      //   slug: "competencias",
      //   i18n: "Materias por Competencias",
      // },
      // {
      //   url: '/directores/estancias',
      //   name: "Estancias / Estadias",
      //   slug: "estancias",
      //   i18n: "Estancias / Estadias",
      // },
    ]
  },

  {
    url: null,
    name: "Horarios",
    slug: "Horarios",
    icon: "CalendarIcon",
    i18n: "GenerarHorarios",
    // tag:"New",
    // tagColor:"green",
    submenu: [

      {
        url: '/idiomas/horariossiguiente',
        name: "Horarios",
        slug: "Horarios",
        i18n: "Horarios",
      },
      {
        url: '/idiomas/directorhorarioprofesor',
        name: "HorarioProfesor",
        slug: "HorarioProfesor",
        i18n: "HorarioProfesor",
      },
      ]
      },
      {
        url: null,
        name: "Profesores",
        slug: "Profesores",
        icon: "BookIcon",
        i18n: "Profesores",
        submenu: [
          {
            url: '/administrativos/cat_profesores',
            name: "CatProfesores",
            slug: "CatProfesores",
            i18n: "Profesores",
            tag:"New",
            tagColor:"green"
          }
    
        ]
      },



]
